module.exports = __webpack_public_path__ + "static/media/smartBannerLogo.e1a9b877.svg";